<template>
  <div class="">
    <Loader v-if="loading" />
    <Toast :title="message" :error="error" :showToast="message !== ''" />
    <div class="card">
      <Section title="اطلاعات کد تخفیف">
        <div class="my-3">
          <BaseText :maxlength="2000" :value="model.title" @input="model.title = $event" title="نام کمپین" placeholder="نام کمپین" />
        </div>
        <div class="my-3">
          <BaseText
            required
            :disable="update"
            :showError="showError"
            :errortext="codeErrorText"
            :maxlength="2000"
            :value="model.code"
            @input="model.code = $event"
            title="کد تخفیف"
            placeholder="کد تخفیف"
          />
        </div>
        <div class="my-3">
          <DateTimeOffset
            range
            :error="showِDateError"
            errorText="لطفا تاریخ را وارد کنید"
            :value="dateRange"
            @input="dateRange = $event"
            title="تاریخ"
            placeholder="تاریخ"
            :hasDefaultDate="false"
            :key="dateRender"
            required
          />
        </div>
        <div>
          <CountInput inputType="number" :value="model.capacity" @input="model.capacity = $event" title="ظرفیت" placeholder="ظرفیت" />
        </div>
        <div class="d-flex justify-content-between my-3">
          <div class="part">
            <div class="w-100">
              <ComboBox
                :searchedData="discountTypes"
                title="نحوه اعمال تخفیف"
                placeholder="نحوه اعمال تخفیف"
                :selectedValue="selectedDiscountType"
                @select="fillSelectedDiscountType"
                :inputStyle="comboStyle"
              />
            </div>
          </div>
          <div class="w-50 ms-4">
            <BaseText
              v-if="model.type === 0"
              inputType="number"
              :maxlength="2000"
              :value="model.percent"
              @input="model.percent = $event"
              title="میزان درصد"
              placeholder="میزان درصد"
            />
            <BaseText v-else :maxlength="2000" :value="model.amount" @input="model.amount = $event" title="مبلغ" placeholder="مبلغ" />
          </div>
        </div>
        <div class="d-flex justify-content-between my-3">
          <div class="part">
            <div class="w-100">
              <BaseText
                :disable="selectedDiscountType === 'مبلغ تخفیف'"
                :maxlength="2000"
                :value="model.upTo"
                @input="model.upTo = $event"
                title="تا سقف (تومان)"
                placeholder="تا سقف"
              />
            </div>
          </div>
          <div class="w-50 ms-4">
            <BaseText :maxlength="2000" inputType="number" :value="model.userCapacity" @input="model.userCapacity = $event" title="تعداد" placeholder="تعداد" />
          </div>
        </div>
        <div class="d-flex">
          <b-form-checkbox v-model="model.applyAfterGeneralDiscount" class="pt-2 me-3">
            <div class="mx-1">اعمال کد تخفیف بعد از تخفیف عمومی</div>
          </b-form-checkbox>
          <b-form-checkbox v-model="applyBeforGeneralDiscount" class="pt-2">
            <div class="mx-1">اعمال کد تخفیف قبل از تخفیف عمومی</div>
          </b-form-checkbox>
        </div>
        <div>
          <b-form-checkbox v-model="isDeactive" @change="setIsEnable" class="pt-2">
            <div class="mx-1">غیرفعال کردن کد تخفیف</div>
          </b-form-checkbox>
        </div>
        <b-form-checkbox v-model="model.selectAll" class="pt-2">
          <div class="mx-1">اعمال روی همه دوره ها و بسته ها</div>
        </b-form-checkbox>
      </Section>
    </div>
    <div v-if="!model.selectAll" class="card p-3">
      <List @selected="(e) => (model.discountProducts = e)" :checkedList="model.discountProducts" :key="dateRender" />
    </div>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.push('/list/discount')">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="addDiscount">ثبت</b-button>
    </div>
  </div>
</template>
<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import Section from '../../common/form/Section.vue'
import CountInput from '../../common/form/CountInput.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import List from '../../list'
import Loader from '../../widgets/loader.vue'
import dadbanDiscountProvider from '../../../services/dadban/discount'
import Toast from '../../common/Toast.vue'
export default {
  components: { BaseText, DateTimeOffset, Section, CountInput, ComboBox, List, Loader, Toast },
  props: {
    update: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showError: false,
      loading: false,
      message: '',
      error: false,
      dateRender: true,
      showِDateError: false,
      codeErrorText: '',
      model: {
        title: '',
        code: '',
        selectAll: false,
        startDate: '',
        endDate: '',
        capacity: '',
        type: '',
        percent: '',
        upTo: '',
        userCapacity: '',
        amount: '',
        isEnable: true,
        applyAfterGeneralDiscount: true,
        discountProducts: [],
      },
      discountTypes: [
        { key: 0, value: 'درصد تخفیف' },
        { key: 1, value: 'مبلغ تخفیف' },
      ],
      isDeactive: false,
      updateForm: false,
      comboStyle: 'color: #495057',
      selectedDiscountType: '',
      dateRange: [],
      applyBeforGeneralDiscount: '',
    }
  },
  watch: {
    'model.selectAll'(c) {
      if (c) {
        this.model.discountProducts = []
      }
    },
    applyBeforGeneralDiscount(c) {
      if (c) {
        this.model.applyAfterGeneralDiscount = false
        return false
      }
      if (!c) {
        this.model.applyAfterGeneralDiscount = true
      }
    },
    'model.applyAfterGeneralDiscount'(c) {
      if (c) {
        this.applyBeforGeneralDiscount = false
        return false
      }
      if (!c) {
        this.applyBeforGeneralDiscount = true
      }
    },
    'model.amount'(c) {
      if (c) {
        this.model.amount = this.model.amount.toString()
        this.model.amount = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'model.upTo'(c) {
      if (c) {
        this.model.upTo = this.model.upTo.toString()
        this.model.upTo = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    dateRange(c) {
      if (c.length > 1) {
        const start = c[0]
        const end = c[1]
        this.model.startDate = start.replaceAll('/', '-') + 'T00:00:00.000Z'
        this.model.endDate = end.replaceAll('/', '-') + 'T00:00:00.000Z'
      }

      if (c.length === 1) {
        this.model.startDate = c[0].replaceAll('/', '-') + 'T00:00:00.000Z'
      }
      if (!c) {
        this.model.startDate = null
        this.model.endDate = null
      }
    },
  },
  mounted() {
    if (this.update) {
      this.fetchDiscount()
    }
    setTimeout(() => {
      this.dateRender = false
    }, 3000)
  },
  methods: {
    setIsEnable(e) {
      if (e === true) {
        this.model.isEnable = false
        this.isDeactive = true
      } else {
        this.model.isEnable = true
        this.isDeactive = false
      }
    },
    async addDiscount() {
      if (!this.dateRange.length) {
        this.showِDateError = true
      } else this.showِDateError = false

      const notPersian = /^[A-Za-z][A-Za-z0-9]*$/.test(this.model.code)
      if (!this.model.code) {
        this.codeErrorText = 'لطفا کد تخفیف را وارد کنید'
        this.showError = true
      } else if (this.model.code && !notPersian) {
        this.codeErrorText = 'لطفا فقط از کاراکترهای انگلیسی و اعداد استفاده کنید'
        this.showError = true
      } else this.showError = false

      if (this.showError || this.showِDateError) {
        window.scrollTo(0, 0)
        return false
      }
      this.loading = true
      this.model.capacity = +this.model.capacity
      this.model.userCapacity = +this.model.userCapacity
      if (this.model.capacity === 0 || !this.model.capacity) {
        this.model.capacity = null
      }
      if (this.model.userCapacity === 0 || !this.model.userCapacity) {
        this.model.userCapacity = null
      }
      if (this.model.upTo === 0 || !this.model.upTo) {
        this.model.upTo = null
      }
      if (this.model.percent === 0 || !this.model.percent) {
        this.model.percent = null
      }

      if (this.model.type === 1) {
        this.model.upTo = null
        this.model.percent = null
      }
      if (this.model.type === 0) {
        this.model.amount = null
      }

      if (this.dateRange.length === 1) {
        this.model.endDate = this.model.startDate
      }
      if (this.model.amount && typeof this.model.amount === 'string') {
        this.model.amount = this.model.amount.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.amount = +this.model.amount
      }
      if (this.model.upTo && typeof this.model.upTo === 'string') {
        this.model.upTo = this.model.upTo.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.upTo = +this.model.upTo
      }

      try {
        if (this.update) {
          const req = await dadbanDiscountProvider.updateDiscount(this.model)
          if (req.status === 200) {
            if (req.data.data.isSuccessful) {
              this.showError = false
              this.$emit('update', !this.updateForm)
              this.loading = false
            } else if (!req.data.data.isSuccessful) {
              this.codeErrorText = 'کد تخفیف تکراری است'
              this.showError = true
              window.scrollTo(0, 0)
            } else {
              this.error = true
              this.loading = false
              this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
            }
          }
          this.loading = false
          return false
        }
        const req = await dadbanDiscountProvider.addDiscount(this.model)
        if (req.status === 200) {
          if (req.data.data.isSuccessful) {
            this.showError = false
            if (req.data.data.id) {
              this.$router.push('/list/discount/detail/' + req.data.data.id)
            } else this.$router.push('/list/discount')
          } else if (!req.data.data.isSuccessful) {
            window.scrollTo(0, 0)
            this.codeErrorText = 'کد تخفیف تکراری است'
            this.showError = true
          } else {
            this.error = true
            this.loading = false
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        this.error = true
        this.message = 'خطایی رخ داده لطفا دوباره سعی کنید'
        this.showToast = true
        setTimeout(() => {
          this.message = ''
          this.error = true
          this.showToast = false
        }, 4000)
      }
    },
    async fetchDiscount() {
      const req = await dadbanDiscountProvider.getDiscount(this.$route.params.id)
      this.model = req.data.data.output
      if (!this.model.applyAfterGeneralDiscount) {
        this.applyBeforGeneralDiscount = true
      }
      if (this.model.startDate) {
        this.dateRange[0] = this.model.startDate.slice(0, 10).replaceAll('-', '/')
      }
      if (this.model.endDate) {
        this.dateRange[1] = this.model.endDate.slice(0, 10).replaceAll('-', '/')
      }

      this.discountTypes.filter((item) => {
        if (item.key === this.model.type) {
          this.selectedDiscountType = item.value
        }
      })
      this.setIsEnable(!this.model.isEnable)
      // this.model.upTo = await this.model.upTo.toString()
      // this.model.amount = await this.model.amount.toString()
    },
    fillSelectedDiscountType(e) {
      this.selectedDiscountType = this.discountTypes.find((item) => item.value === e).value
      this.model.type = this.discountTypes.find((item) => item.value === e).key
    },
  },
}
</script>
<style lang="scss" scoped>
.part {
  display: inline-flex;
  width: 50%;
}
</style>
